var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-section",
    {
      attrs: {
        id: "room-results",
        title: _vm.$t("booking.sectionTitles.roomResults"),
        contentClass: "",
        collapsed: _vm.moduleCollapsed
      },
      on: { "section-clicked": _vm.sectionClicked }
    },
    [
      _vm.loaded && !_vm.errorState
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _vm.result && _vm.result.global.is_short_term
                ? _c("div", { staticClass: "column small-12" }, [
                    _c("div", {
                      staticClass: "booking-element booking-error",
                      domProps: {
                        innerHTML: _vm._s(_vm.result.global.short_term_notice)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorResults.length > 0 && _vm.fullResults.length == 0
                ? _c("div", { staticClass: "column small-12" }, [
                    _c(
                      "div",
                      { staticClass: "booking-element booking-error" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.errorResults[0][0].message) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                : _vm._l(_vm._.sortBy(_vm.fullResults, "price"), function(
                    curResult
                  ) {
                    return _c(
                      "div",
                      {
                        staticClass: "column small-12 medium-12 large-4 room",
                        class: { "is-holiday-package": curResult.package_name }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "booking-element room-result--top spacer-mini"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "room__title" },
                              _vm._l(_vm.roomResultName(curResult), function(
                                r,
                                i
                              ) {
                                return _c("span", [
                                  i > 0 ? _c("span", [_vm._v("+")]) : _vm._e(),
                                  _vm._v(_vm._s(r) + "\n              "),
                                  _c("br")
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "room__img",
                                style: _vm.bgImage(curResult.picture_url)
                              },
                              [
                                curResult.package_name
                                  ? _c(
                                      "div",
                                      { staticClass: "special-indicator" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "special-indicator--label"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(curResult.package_name)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "room__description text-xsmall" },
                              _vm._l(curResult.description, function(desc) {
                                return _c(
                                  "div",
                                  { staticClass: "room__description--label" },
                                  [_vm._v(_vm._s(desc))]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            !curResult.loading
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "room__price spacer-small",
                                      class: {
                                        "special-offer":
                                          curResult.is_special_offer
                                      }
                                    },
                                    [
                                      curResult.is_special_offer
                                        ? _c("span", [
                                            _vm._v("SPECIAL OFFER: ")
                                          ])
                                        : _vm._e(),
                                      _vm._v(
                                        "ab " +
                                          _vm._s(
                                            _vm.formatNumber(curResult.price_pp)
                                          ) +
                                          " p. Erw.\n              "
                                      ),
                                      curResult.calculation_data[0].api_meta &&
                                      curResult.calculation_data[0].api_meta
                                        .non_refundable
                                        ? _c(
                                            "div",
                                            { staticClass: "error small" },
                                            [_vm._v("nicht stornierbar")]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-xsmall text-right metainfo"
                                    },
                                    [
                                      _vm._v(
                                        "\n              ab " +
                                          _vm._s(curResult.price_display) +
                                          " gesamt für alle Reisende\n              "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(curResult.type_name) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "metainfo" }, [
                                    _vm._v(_vm._s(curResult.result_name))
                                  ]),
                                  _vm._v(" "),
                                  curResult.flight &&
                                  curResult.flight.offset_notice
                                    ? _c(
                                        "div",
                                        { staticClass: "metainfo text-xsmall" },
                                        [
                                          _vm._v(
                                            "\n              Bitte beachten Sie, das sich aufgrund der Flugzeit der Aufenthalt vor Ort um einen Tag verkürzt\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _c("loader", {
                                  attrs: {
                                    title: "Preis wird ermittelt",
                                    details: "Einen Moment bitte"
                                  }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !curResult.loading
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "booking-element room-result--bottom"
                              },
                              [
                                _c("div", { staticClass: "row room__prices" }, [
                                  _c(
                                    "div",
                                    { staticClass: "column small-12" },
                                    [
                                      _vm._l(curResult.result_names, function(
                                        detail
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass:
                                              "room__prices__info text-xsmall"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(detail.count) + "x")
                                            ]),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.splittedDetails(
                                                    detail.name
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _vm.result &&
                                      !_vm.result.global.is_short_term
                                        ? _c("div", [
                                            curResult.flight
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "cta cta--small",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getFlightResults(
                                                          curResult
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "svg-icon",
                                                      attrs: {
                                                        src:
                                                          "/images/icons_svg/airplane-icon.svg"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                  Auswählen\n                "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "cta cta--small",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sendBookingProceed(
                                                          curResult
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Auswählen\n                "
                                                    )
                                                  ]
                                                )
                                          ])
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
              _vm._v(" "),
              _vm.resultData.length - _vm.fullResults.length > 0
                ? _c(
                    "div",
                    { staticClass: "column small-12 text-center" },
                    [
                      !_vm.updatingResults
                        ? [
                            _vm.resultData.length !=
                            _vm.errorResults.length + _vm.fullResults.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "cta cta--inline cta--dark",
                                    on: { click: _vm.loadBookingResultDetails }
                                  },
                                  [
                                    _vm._v(
                                      "\n            Mehr Ergebnisse laden \n            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n            noch " +
                                        _vm._s(
                                          _vm.resultData.length -
                                            _vm.fullResults.length
                                        ) +
                                        " verbleibend\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "metainfo text-center" })
                          ]
                        : _c("loader", {
                            attrs: { title: "Zimmer werden geladen" }
                          })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loadedResultsCount == 0
                ? _c("loader", {
                    attrs: {
                      title: "Ergebnisse werden geladen",
                      details:
                        "Noch " +
                        (_vm.resultData.length - _vm.fullResults.length) +
                        " verbleibend"
                    },
                    on: { click: _vm.loadBookingResultDetails }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm.loaded && _vm.errorState
        ? _c(
            "div",
            [
              _c("error-message", {
                attrs: { errors: _vm.errors },
                on: {
                  "step-back": function($event) {
                    return _vm.stepBackTo("datepicker")
                  }
                }
              })
            ],
            1
          )
        : _vm.result &&
          _vm.result.global.flight &&
          _vm.result.global.status == "NOK"
        ? _c("div", { staticClass: "column small-12" }, [
            _c("div", { staticClass: "booking-element booking-error" }, [
              _c("h3", [
                _c("b", [
                  _vm._v(
                    "Für den aktuellen Zeitraum stehen leider keine Flüge zur Verfügung"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Aufgrund der aktuell geltenden internationalen Einschränkungen im Flugverkehr sind für Ihre Anfrage leider keine Flugverbindungen vorhanden."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        Bitte wählen Sie einen anderen Flughafen oder ein anderes Reisedatum."
                ),
                _c("br"),
                _vm._v(
                  "\n        Gerne können Sie sich auch direkt an unseren Kundenservice wenden – dieser wird für Sie ein passendes individuelles Angebot erstellen.\n      "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-center" }, [
                _c(
                  "a",
                  {
                    staticClass: "cta cta--inline",
                    attrs: {
                      target: "blank",
                      href:
                        "/kontaktanfrage?topic=" +
                        _vm.result.global.request_topic
                    }
                  },
                  [_vm._v("Kundenservice kontaktieren")]
                )
              ])
            ])
          ])
        : _c("loader", {
            attrs: {
              title: "Aktuelle Verfügbarkeiten werden geprüft",
              details: "Einen Augenblick bitte"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }